module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: ["dof-checkbox-list"]
  }, _vm._l((_vm.list), function(item, i) {
    return _c('dof-checkbox', _vm._b({
      key: i,
      attrs: {
        "hasTopBorder": i === 0 && _vm.needShowTopBorder ? true : false,
        "itemImg": item.itemImg,
        "hasSubBottomBorder": _vm._isColmo ? true : _vm.hasBorder
      },
      on: {
        "dofCheckBoxItemChecked": _vm.dofCheckBoxItemChecked
      }
    }, 'dof-checkbox', item, false))
  }))
},staticRenderFns: []}
module.exports.render._withStripped = true


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/template-compiler.js?id=data-v-1043fc76!./~/weex-vue-loader/lib/selector.js?type=template&index=0!./packages/dof-checkbox-list/index.vue
// module id = 567
// module chunks = 0 1